var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5417 4.16669C31.8584 4.42335 33.4167 5.00169 34.58 6.31169C36.6667 8.66169 36.6667 12.44 36.6667 20C36.6667 27.56 36.6667 31.34 34.58 33.6884C33.4167 34.9984 31.8567 35.5767 29.5417 35.8334M10.4584 35.8334C8.14171 35.5767 6.58337 34.9984 5.42004 33.6884C3.33337 31.3384 3.33337 27.56 3.33337 20C3.33337 12.44 3.33337 8.66002 5.42004 6.31169C6.58337 5.00169 8.14337 4.42335 10.4584 4.16669M25 24.165C24.9967 25.045 24.9717 25.5234 24.75 25.8817C24.2067 26.7684 23.1234 26.6634 22.2067 26.6634H18C16.155 26.6634 15.2317 26.6634 15.0334 26.1184C14.8367 25.575 15.5384 24.9617 16.94 23.7317L19.7567 21.265C20.4267 20.6767 20.7634 20.3817 20.7634 20C20.7634 19.6167 20.4267 19.3234 19.7567 18.735L16.94 16.2684C15.54 15.04 14.8367 14.425 15.035 13.8817C15.2317 13.3367 16.155 13.3367 18.0017 13.3367H22.2084C23.125 13.3367 24.2084 13.2317 24.7517 14.1167C24.9734 14.4767 24.9984 14.955 25.0017 15.835",
    stroke: "#0073C0",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSum);
export default __webpack_public_path__ + "static/media/Sum.19570072e2942813b234830ad78a83e0.svg";
export { ForwardRef as ReactComponent };